import { AddButton } from '@/common/buttons/AddButton';
import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { EntityUtils } from '@/common/utils/EntityUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const IncListList = ({ filterId }) => {
  const augRowsReq = useCallback(EntityUtils.parentFilterAugRowsReq('FILTER', filterId), [filterId]);

  const augTabButtons = (buttons) => {
    if (!filterId) return;

    // The generic Add button defaults parent FK's off the route entity (Pol), which doesn't match
    // IncList's filterId field, so it's replaced with one that defaults filterId directly.
    ObjUtils.clearObj(buttons);
    buttons.push(
      <AddButton
        key="addButton"
        entity="INC_LIST"
        augNavEntityObj={(navEntityObj) => {
          navEntityObj.filterId = filterId;
        }}
      />,
    );
  };

  return <EntityList entity="INC_LIST" augRowsReq={augRowsReq} augTabButtons={augTabButtons} />;
};
